module.exports = __webpack_public_path__ + "img/sdg17.72715dd0.svg";